/**
 * Shared PrimeReact `Dialog` passthrough.
 *
 * Every dialog in the app takes the same 16 px card as the pages behind it, the same 24 px
 * gutter, and a header that reads as a panel title rather than as a browser chrome bar. The
 * `dark:` classes are PrimeReact's own and are kept so the passthrough stays a drop-in; the app
 * itself never turns dark mode on.
 */
export const TOOL_MANAGEMENT_DIALOG_PT = {
  root: {
    className: 'border border-gray-200 rounded-2xl shadow-lg dark:border-gray-700 max-h-[90%] transform scale-100 m-0',
  },
  header: {
    className:
      'flex items-center justify-between shrink-0 bg-white text-gray-900 text-lg font-semibold border-b border-gray-200 rounded-tl-2xl rounded-tr-2xl px-6 py-4 dark:bg-gray-900 dark:text-white/80 dark:border-gray-700',
  },
  content: {
    className: 'overflow-y-auto bg-white text-gray-700 px-6 py-4 dark:bg-gray-900 dark:text-white/80',
  },
  footer: {
    className:
      'flex gap-2 shrink-0 justify-end align-center border-t border-gray-200 bg-white text-gray-700 px-6 pb-6 text-right rounded-b-2xl dark:bg-gray-900 dark:text-white/80 dark:border-gray-700',
  },
};
